import { render } from "./JuntaPicker.vue?vue&type=template&id=25d1a83b&scoped=true"
import script from "./JuntaPicker.vue?vue&type=script&lang=ts"
export * from "./JuntaPicker.vue?vue&type=script&lang=ts"

import "./JuntaPicker.vue?vue&type=style&index=0&id=25d1a83b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25d1a83b"

export default script